import { TendenciaLabel } from "../../ui/Tendencia";
import { calcularDerivadosExperiencia } from "../domain";
import type { MomentoMusical } from "../types";
import { EngajamentoMini } from "./EngajamentoMini";

/**
 * Indicador compacto de evolução para linhas de lista: mini-escada (passo máximo) +
 * contagem de momentos + tendência. "Bater o olho e ver que está engajando mais"
 * — o coração do valor do módulo (P0.4).
 */
export function IndicadorEngajamento({
  experienciaId,
  momentos,
}: {
  experienciaId: string;
  momentos: MomentoMusical[];
}) {
  const d = calcularDerivadosExperiencia(experienciaId, momentos);

  if (d.n_momentos === 0) {
    return <div className="evol evol-vazio">ainda sem momentos</div>;
  }

  return (
    <div className="evol">
      <EngajamentoMini passo={d.passo_maximo} />
      <span className="evol-meta">
        {d.n_momentos} {d.n_momentos === 1 ? "momento" : "momentos"}
      </span>
      {d.tendencia !== "poucos_dados" && <TendenciaLabel tendencia={d.tendencia} />}
    </div>
  );
}
